import { useEffect } from 'react';

import styled from '@emotion/styled';

import { useAppStore } from 'src/hooks/useAppStore';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import {
  disableBackgroundScrolling,
  enableBackgroundScrolling
} from 'src/utils/common';
import { USER_TOKEN } from 'src/utils/constants/localStorageConstants';
import { HeaderLinks } from 'src/utils/constants/RouterConstants';
import { ZEE5_LOGOS } from 'src/utils/constants/utilConstants';
import { navigationHandler } from 'src/utils/UtilityMethods';

import HamburgerMenu from './HamburgerMenu';
import {
  buttonsContainer,
  CloseButton,
  MobileMenuHeader,
  outlineButton,
  purpleBackground,
  purpleButton,
  userNameContainer,
  userProfile,
  Zee5LogoContainer
} from './HamburgerMenuWrapperStyles';
import {
  MIXPANEL_LOGIN,
  MIXPANEL_REGISTER
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import {
  HamburgerMenuAlt,
  HamburgerMenuUrls
} from '../../utils/constants/stringConstants';
import Portal from '../portal/Portal';
import { profileMenuHeader } from '../profileMenu/ProfileMenu';
import {
  ProfileMenuHeader,
  UserProfile,
  ViewAllButton
} from '../profileMenu/ProfileMenuStyle';
import Zee5Logo from '../Zee5Logo';

type PortalProps = {
  hamburgerMenuCLickHandler: () => void;
  showHamburgerMenu: boolean;
  isMobile: boolean;
};

const OutlineButton = styled.button`
  ${outlineButton}
`;

const PurpleButton = styled.button`
  ${purpleButton}
`;

const HamburgerMenuWrapper = ({
  hamburgerMenuCLickHandler,
  showHamburgerMenu,
  isMobile
}: PortalProps) => {
  const { translations, usersData } = useAppStore();
  const HeaderStrings = translations?.common;
  const token = getLocalStorage(USER_TOKEN);
  const userName = usersData?.first_name || 'guest';

  useEffect(() => {
    disableBackgroundScrolling();
    return enableBackgroundScrolling;
  }, []);

  return (
    <Portal
      onClick={hamburgerMenuCLickHandler}
      show={showHamburgerMenu}
      data-testid="hamburger-menu-portal">
      <>
        {isMobile && (
          <>
            <div css={MobileMenuHeader}>
              <button css={CloseButton}></button>
              <div css={Zee5LogoContainer}>
                {/* <img
                  css={Zee5Logo}
                  src={HamburgerMenuUrls.ZEE5_LOGO}
                  alt={HamburgerMenuAlt.ZEE5_LOGO}
                /> */}
                <Zee5Logo
                  logoType={ZEE5_LOGOS.ZEE5_LOGO}
                  alt={HamburgerMenuAlt.ZEE5_LOGO}
                  width="40px"
                  height="40px"
                />
              </div>
            </div>
            {token ? (
              <ProfileMenuHeader
                css={[purpleBackground, userNameContainer]}
                onClick={profileMenuHeader}>
                <UserProfile css={userProfile} />
                <div>{userName}</div>
                <ViewAllButton />
              </ProfileMenuHeader>
            ) : (
              <div css={buttonsContainer}>
                <OutlineButton
                  onClick={(e) => {
                    navigationHandler(HeaderLinks.SIGN_IN, MIXPANEL_LOGIN, e);
                  }}>
                  {HeaderStrings?.LOGIN}
                </OutlineButton>
                <PurpleButton
                  onClick={(e) => {
                    navigationHandler(
                      HeaderLinks.REGISTER,
                      MIXPANEL_REGISTER,
                      e
                    );
                  }}>
                  {HeaderStrings?.SIGN_UP}
                </PurpleButton>
              </div>
            )}
          </>
        )}
        <HamburgerMenu
          isMobile={isMobile}
          showHamburgerMenu={showHamburgerMenu}
          hamburgerMenuCLickHandler={hamburgerMenuCLickHandler}
        />
      </>
    </Portal>
  );
};

export default HamburgerMenuWrapper;
